export function deriveLessonPacing(snapshot, elapsedSinceSyncMs = 0) {
    if (!snapshot || !Number.isFinite(Number(snapshot.duration_seconds))) return null;
    const elapsedAtSync = Math.max(0, Math.floor(Number(snapshot.elapsed_seconds) || 0));
    const elapsedSinceSync = snapshot.is_on_break
        ? 0
        : Math.max(0, Math.floor((Number(elapsedSinceSyncMs) || 0) / 1000));
    const elapsedSeconds = elapsedAtSync + elapsedSinceSync;
    const durationSeconds = Math.max(0, Math.floor(Number(snapshot.duration_seconds)));
    return {
        elapsedSeconds,
        durationSeconds,
        remainingSeconds: Math.max(0, durationSeconds - elapsedSeconds),
        visibleToStudents: snapshot.visible_to_students === true,
        isOnBreak: snapshot.is_on_break === true,
    };
}

export function formatLessonTime(value) {
    const seconds = Math.max(0, Math.floor(Number(value) || 0));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainder = seconds % 60;
    return [hours, minutes, remainder].map(part => String(part).padStart(2, '0')).join(':');
}
